import { format } from 'date-fns'

export const formatDateTime = (value?: string | null) => (value ? format(new Date(value), 'd MMM yyyy, HH:mm') : '—')

/** Discrepancy as signed money: short of cash is negative. */
export const signed = (value: number | null | undefined, formatCurrency: (n: number) => string) =>
  value === null || value === undefined ? '—' : `${value > 0 ? '+' : ''}${formatCurrency(value)}`
